<template>
	<div class="headerBox" >
		<div class="box1">
			<div class="cont mainCont">
				<div class="c_left">
					<div>
						<i class="iconfont icon-address2"></i>
						<!-- <span class="city">郑州</span>
						<i class="iconfont icon-down"></i> -->
						<el-select v-model="city" filterable placeholder="请选择" @change="cityChange">
							<el-option
							  v-for="item in cityArr"
							  :key="item.id"
							  :label="item.name"
							  :value="item.name">
							</el-option>
						</el-select>
					</div>
					<span class="shu"></span>
					<a href="/" class="tit">欢迎来到鲸蜗家庭报修</a>
				</div>
				<a :href="'tel:'+tel" class="c_right">客服电话：{{tel2}}</a>
			</div>
		</div>
		<div class="box2">
			<div class="cont mainCont">
				<div class="bTop">
					<div class="logo"><a href="/"><img src="../../../static/logo.png" alt=""></a></div>
					<div class="searchBox">
						<el-input class="input" v-model="val" placeholder="请输入搜素关键词"></el-input>
						<el-button type="primary" @click="goSearch()">搜索</el-button>
					</div>
					<a :href="'tel:'+tel" class="telox">
						<img src="../../../static/tel.png" alt="tel" class="tel">
						<div class="txt">
							<h4>{{tel}}</h4>
							<p>服务热线</p>
						</div>
					</a>
				</div>
				<div class="bNav">
					<h3 class="tit">鲸蜗家庭报修</h3>
					<ul>
						<li v-for="(item,index) in navList" :key="index" :class="navIndex==index?'active':''" @click="navChange(index)"><a href="javascript:;void(0)">{{item.title}}</a></li>
					</ul>
				</div>
			</div>
		</div>

		<!-- 右侧悬浮 -->
		<div class="offsideBox">
			<ul>
				<li class="">
					<i class="iconfont icon-kefu1"></i>
					<p>在线客服</p>
					<a href="https://bx.soboten.com/chat/h5/v6/index.html?sysnum=6d3594e56a994dc59b789d1b3c80f3e6" target='_blank' class="lBox">
						<h5>在线客服</h5>
						<div class="t">鲸蜗在线客服为您提供专业服务</div>
					</a>
				</li>
				<li>
					<i class="iconfont icon-tel"></i>
					<p>电话咨询</p>
					<a  :href="'tel:'+tel"class="lBox">
						<h5>电话咨询</h5>
						<div class="t">鲸蜗服务热线：{{tel}}</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import {getCityList,getLocationByIp} from '@/api/api'
	import { EventBus,setGlobalVar } from '@/utils/event-bus.js';

	import MobileDetect from 'mobile-detect';
export default {
	name: 'Navbar',
	components: {},
	props:{
		tel:{
			type:String,
			default:''
		},
		tel2:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			cityArr:[],
			city:'',
			val:'',
			navList:[
				{path:'/',title:'首页'},
				{path:'/server',title:'服务项目'},
				{path:'/reservation',title:'免费报修'},
				{path:'/master',title:'平台师傅'},
				{path:'/cooperate',title:'加盟合作'},
				{path:'/codeQuery',title:'故障代码查询'},
				{path:'/repairWay',title:'修理小智慧'},
				{path:'/aboutUs',title:'关于我们'},
			],
			 navIndex:0,
			 // 从 localStorage 获取保存的 navIndex，若没有则默认为 0
      //navIndex: localStorage.getItem('navIndex') ? parseInt(localStorage.getItem('navIndex')) : 0
		};
	},
	watch:{
		"$route":{
			handler(route){
				try {
					// console.log('route::',route.path)
					let url = route.path;
					let navIndex = '-1';
					this.navList.forEach((ele,i)=>{
						if(ele.path==url||url.indexOf(ele.path)!=-1){
							navIndex = i;
						}
					})
					if(navIndex==0&&url!='/'){
						this.navIndex = '-1';
					}else{
						this.navIndex = navIndex;
					}
				// 将当前选中的 navIndex 保存到 localStorage
      localStorage.setItem('navIndex', this.navIndex);	
				} catch (error) {
					
				}
			},
			deep:true,
		}
	},
	mounted() {
 // 获取当前路由的路径
  const currentPath = this.$route.path;

  // 从 localStorage 获取保存的 navIndex
  const savedNavIndex = localStorage.getItem('navIndex');

  // 如果 localStorage 中有保存的 navIndex，则使用它
  if (savedNavIndex !== null) {
    this.navIndex = parseInt(savedNavIndex);
  } else {
    // 默认设置首页的索引为 0
    this.navIndex = 0;
  }

  // 如果当前是首页并且 localStorage 中保存的 navIndex 不是 0，则设置为 0
  if (currentPath === '/' && this.navIndex !== 0) {
    this.navIndex = 0;
  }


		this.getLocationByIp();

		 const md = new MobileDetect(window.navigator.userAgent);
		  console.log('Device OS:', md);
 // 检测设备类型
console.log('Is Mobile:', md.mobile());  // 检测是否是手机
console.log('Is Tablet:', md.tablet());  // 检测是否是平板
console.log('Is Desktop:', md.device() === 'desktop');  // 检测是否是桌面

// 获取设备操作系统和浏览器信息
console.log('OS:', md.os());  // 获取操作系统（如 iOS, Android）
console.log('Browser:', md.browser());  // 获取浏览器名称

// 检查设备是否为 Android 或 iOS
console.log('Is Android:', md.is('android'));  // 检测是否为 Android 系统
console.log('Is iOS:', md.is('ios'));  // 检测是否为 iOS 系统
  //  console.log('Device Browser:', md.browser());

	},
	methods: {
		getLocationByIp(){
			getLocationByIp({}).then(res => {
			    console.log("666666")
				console.log(res)
				console.log("666")
				if(res.data){
					this.city = res.data;
					this.getCity();
					setGlobalVar(res.data)

        // 使用 Vuex 更新 globalVar
        this.$store.dispatch('updateGlobalVar', res.data);  // 通过 Vuex Action 更新 globalVar

				}
			})
		},
		getCity(){
			getCityList({}).then(res => {
				console.log(res)
				let list = res.data.list;
				let arr = [];
				list.forEach(ele => {
					arr = arr.concat(ele.data)
				});
				this.cityArr = arr;
			})
		},
		// 选中值发生变化时触发
		cityChange(val){
			console.log(val)
			setGlobalVar(val)
		},
		navChange(i){
			this.navIndex = i;
			  localStorage.setItem('navIndex', i);
			//localStorage.setItem('navIndex', i);  // 将选中的索引保存到 localStorage
			let item = this.navList[i];
			this.$router.push(item.path)
		},
		goSearch(){
			this.$router.push({
			path: '/search',
				query: {
					val: this.val
				}
			})
		}
	},
};
</script>

<style lang="scss">
.headerBox{background-color: #1B1E2D;position: sticky;top:0;z-index:10;
	.box1{height: 40px;background: #F8F8F8;
		.cont{height: 40px;display: flex;align-items: center;justify-content: space-between;
			.c_left{display: flex;align-items: center;cursor: pointer;
				i{color: #1F263F;font-size: 12px;}
				.city{color: #1F263F;font-size: 14px;margin-left: 8px;margin-right: 6px;}
				.icon-down{color: #A4A9B7;}
				.shu{width: 1px;height: 11px;background-color: #EDEEF1;display: inline-block;margin: 0 16px;}
				.tit{color: #999999;font-size: 12px;}
				&:hover{
					.tit{color: #2F78FF;}
				}
				.el-select{width: 75px;border: none;background: transparent;
					&::after{display: none;}
					&::before{display: none;}
					.el-input__inner{border: none !important;background: transparent;padding-left: 0;}
				}
			}
			.c_right{color: #999999;font-size: 12px;transition: all .3s;
				&:hover{color: #2F78FF;}
			}
		}
	}
	.box2{background-color: #FFFFFF;border-bottom: 2px solid #2F78FF;
		.cont{
			.bTop{display: flex;align-items: center;justify-content: space-between;padding-top:22px;
				.logo{color: #1F263F;font-size: 50px;flex: 1;
					img{width: 90px;}
				}
				.searchBox{width: 636px;border-radius:8px;border: 2px solid #2F78FF;display: flex;align-items: center;overflow: hidden;
					.el-input__inner{background-color: transparent;height: 40px;border-radius:4px 0 0 4px;color: #1F263F;font-size: 14px;border: 0;}
					.el-button{width: 100px;height: 40px;border-radius:0;border: 0;border: 0;}
				}
				.telox{display: flex;align-items: center;flex: 1;justify-content: flex-end;
					.tel{width: 34px;height: 34px;margin-right: 10px;}
					.txt{
						h4{color: #000000;font-size: 24px;font-weight: bold;}
						p{color: #6B738B;font-size: 12px;}
					}
				}
			}
			.bNav{display: flex;align-items: center;padding-top:40px;
				.tit{width: 270px;height: 48px;line-height: 48px;background: #2F78FF;color: #FFFFFF;font-size: 20px;text-align: center;}
				ul{margin-left: 40px;display: flex;align-items: center;margin-right: -28px;
					li{margin-right: 28px;
						a{color: #1F263F;font-size: 18px;cursor: pointer;transition: all .3s;}
						&.active,&:hover{
							a{color: #2F78FF;font-weight: bold;}
						}
					}
				}
			}
		}
	}

	.offsideBox{position: fixed;top: 30%;right: 6%;z-index: 10;
		ul{width: 74px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(215,215,215,0.25);border-radius: 20px;padding: 6px;
			li{width: 62px;height: 72px;border-radius: 20px;cursor: pointer;text-align: center;transition: all .3s;padding-top: 13px;position: relative;
				&:last-child{margin-top: 10px;}
				i{color: #A4A9B7;font-size: 20px;transition: all .3s;}
				p{transition: all .3s;color: #1F263F;font-size: 12px;margin-top: 10px;}
				.lBox{opacity: 0;;width: 230px;position: absolute;left: 0;top: 0;padding: 16px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(215,215,215,0.25);border-radius: 10px;border: 1px solid #EDF3F8;
					transition: all .3s;
					h5{color: #2F78FF;font-size: 14px;font-weight: bold;margin-bottom: 10px;text-align: left;}
					.t{color: #A4A9B7;font-size: 14px;text-align: left;}
				}
				&.active,&:hover{background-color: #2F78FF;
					i,p{color: #fff;}
					.lBox{display: block;left: -244px;opacity: 1;}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/layout/components/header.vue